<div class="statuses_container">
  <div *ngFor="let status of statuses"
       class="status_title"
       (click)="onSetFilter(status)"
  >
    <p>{{status.name}}</p>
    <span class="check_label" *ngIf="checkSelectedStatus[status.type]"></span>
  </div>
</div>
